module.exports = __webpack_public_path__ + "img/pic_app02.1d7cac18.png";